import type { CampusScaleSummary } from '../domain';

export const CAMPUS_DATASET_VERSION = 3;
export const CAMPUS_DATASET_SEED = 42;
export const CAMPUS_PROFILE_ID = 'mid-sized-community-college-v1';

export const CAMPUS_ASSET_COUNTS = {
  desktops: 1500,
  issuedLaptops: 1100,
  labWorkstations: 750,
  libraryComputers: 110,
  kiosks: 45,
  mobilePhones: 240,
  tablets: 350,
  deskPhones: 650,
  emergencyPhones: 140,
  intercoms: 200,
  videoConference: 70,
  lecterns: 230,
  printers: 230,
  specialtyPrinters: 75,
  digitalSigns: 170,
  displays: 325,
  labDevices: 225,
  cameras: 600,
  doorReaders: 250,
  alarmPanels: 45,
  buildingControllers: 225,
  hvacSensors: 1100,
  lightingControllers: 350,
  vending: 35,
  parking: 30,
  physicalServers: 30,
  virtualServers: 225,
  storage: 6,
  backups: 5,
  identity: 7,
  logging: 4,
  coreRouters: 4,
  edgeRouters: 3,
  firewalls: 3,
  coreSwitches: 6,
  buildingSwitches: 82,
  aps: 425,
  monitoring: 5,
  loadBalancers: 7,
  cellRepeaters: 25
} as const;

export const MANAGED_ASSET_TOTAL = Object.values(CAMPUS_ASSET_COUNTS)
  .reduce((total, count) => total + count, 0);

export const CAMPUS_SCALE_PROFILE: CampusScaleSummary = {
  profileId: CAMPUS_PROFILE_ID,
  buildings: 16,
  employees: 1100,
  installedJacks: 3650,
  activeJacks: 2800,
  wirelessAccessPoints: CAMPUS_ASSET_COUNTS.aps,
  managedAssets: MANAGED_ASSET_TOTAL,
  observedDevices: 2618,
  identifiableDevices: 12500,
  typicalWeekdayPersonalDevices: 9100,
  peakConnectedDevices: 6200
};

if (
  CAMPUS_SCALE_PROFILE.managedAssets + CAMPUS_SCALE_PROFILE.observedDevices
  !== CAMPUS_SCALE_PROFILE.identifiableDevices
) {
  throw new Error('Campus scale profile totals must reconcile.');
}

